<div class="column-header centre-align" [formGroup]="filterForm" >
  <div style="padding: 5px" class="header-cell-text">{{ column.header }}</div>
  <div *ngIf="column.filterable">
    <ng-container *ngIf="column.type === 'DATE'; else defaultFilter">
      <mat-form-field
        [style.maxWidth.px]="220"
        (click)="stopPropagation($event)">
        <mat-label>Filter {{ column.header }}</mat-label>
        <input
          matInput
          [formControlName]="column.columnDef"
          (click)="stopPropagation($event)"
          [matDatepicker]="dp3"
          readonly />
        <mat-icon matDatepickerToggleIcon (click)="clearDatepicker(column.columnDef)" style="padding-right: 5px">clear</mat-icon>
        <mat-datepicker-toggle matIconSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #defaultFilter>
      <ng-container *ngIf="column.type === 'LIST'; else textFilter">
        <mat-form-field class="no-padding"
          appearance="fill"
          [style.maxWidth.px]="140"
          (click)="stopPropagation($event)">
          <mat-select
            (click)="stopPropagation($event)"
            [formControlName]="column.columnDef"
            placeholder="Filter {{ column.header }}">
            <mat-option *ngFor="let option of column.listOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-template #textFilter>
        <mat-form-field [ngClass]="column.header != 'Run Number' ? 'no-padding' : ''"
          appearance="fill"
          [style.maxWidth.px]="140"
          [style.width.px]="column.width"
          (click)="stopPropagation($event)">
          <input
            matInput
            (click)="stopPropagation($event)"
            [formControlName]="column.columnDef"
            placeholder="Filter {{ column.header }}" />
        </mat-form-field>
      </ng-template>
    </ng-template>
  </div>
</div>
